<template>
    <div id="pt060" class="pt060">
        <div class="loginTitle">
            <img class="loginIcon"/>
            <!-- ようこそ -->
            <span class="loginWelcome">{{$t('pt060.labels.welcome')}}</span>
        </div>
        <div v-if="pt060Init.isLogin == false" class="loginMain">
            <div class="loginMess">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt060'"/> 
            </div>
            <!-- error area -->
            <div class="loginMail">
                <!-- メールアドレス  -->
                <span id="mailAddress_lbl">{{pt060Init.loginIdNm}}</span>
                <input-check v-model="pt060Request.mailAddress" class="mailAddress mail" maxlength="80" tabindex=1 type="text" autocomplete="off"/>
                <span>{{pt060Init.mailAddress}}</span>
            </div>
            <div class="loginPassword">
                <!-- パスワード -->
                <span for="password">{{$t('common.labels.password')}}</span>
                <input-check v-model="pt060Request.password" class="password" maxlength="16" id="password" tabindex=2 type="password" autocomplete="off"/>
            </div>
            <div class="loginUser">
                <!-- ログイン -->
                <button @click="doLogin();" type="button" class="btnLogin">{{$t('common.buttons.login')}}</button>
            </div>
            <div id="forgetMailPass" class="passwordLink">
                <!-- パスワードを忘れた方 -->
                <router-link :to="generateLinkParams(14, pt060Init.rePassPage)" class="forgetPass">
                    {{$t('pt060.labels.forgetPass')}}
                </router-link>
            </div>
            <div class="loginBorder">
            </div>
            <div class="loginFirstPerson">
                <!-- はじめてのかたはこちら -->
                <span >{{$t('pt060.labels.firstPerson')}}</span>
            </div>
            <div class="loginNewMember">
                <!-- 新規会員登録 -->
                <button @click="doEntry();" type="button" class="btnRegisterMember">{{$t('common.buttons.registerMember')}}</button>
            </div>
        </div>
        <div v-if="pt060Init.isLogin == true" class="loggingUser">
            <div class="customName">
                <span>
                    <!-- 様 -->
                    {{pt060Init.customName}} {{$t('pt060.labels.mr')}}
                </span>
            </div>
            <div class="cancelUser">
                <!-- ログアウト -->
               <button @click="doLogout();" type="button" class="btnUserCancel">{{$t('common.buttons.logout')}}</button>
            </div>
        </div>

        <alert-confirm
            v-if="isShowAlert"
            v-bind:msgConfirm="$t('pt060.labels.msgConfirmLogout')"
            :okAction="_logout"
            size="md"/>

        <alert-confirm 
            v-if="isShowWarn"
            :msgConfirm="msgConfirm"
            :okAction="doAction"
            :cancelAction="cancelAction"
            :size="'lg'"
            @closedModal="isShowWarn = false"
        />
    </div>
</template>
<script>
/* eslint-disable */
import common from 'assets/js/common';
import axios from "assets/js/request";
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck';
import AlertConfirm from 'components/AlertConfirm';
import SiteConstants from 'assets/const/SiteConstants.json';
import EventBus from "assets/js/eventBus";

export default {
    name: "PT060LoginParts",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    components:{
        InputCheck,
        Message,
        AlertConfirm
    },
    data() {
        return {
            pt060Request:{
                mailAddress: '',
                password: '',
                shahanFlg: '',
            },

            pt060Init:{},
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            SiteConstants: SiteConstants,
            isShowAlert: false,
            site: "",
            currentURL: sessionStorage.currentURL ? sessionStorage.currentURL : '',
            isShowWarn: false,
            confirmActionFlg: 0,
            msgConfirm: null
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        _this.currentURL = _this.$route.fullPath;

        if (_this.ptInitData){
            _this.pt060Init = _this.ptInitData;
        }else{
            // Call API login
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT060 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt060Init = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        _this.pt060Request.shahanFlg = _this.pt060Init.shahanFlg;

        EventBus.$on('closed', () => {
            _this.isShowAlert = false;
        });
    },
    methods: {
        /*
        * login system
        */
        doLogin: function(){
            var _this = this;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt060');
            _this.$emit("event-loading", true);
            // Call API login
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT060 + _this.$UrlConstants.LOGIN, _this.pt060Request).then(function(response) {
                if(response.data.status == 'OK') {
                    let loginProblem = response.data.response.loginProblem;
                    let loginMsg = response.data.response.loginMsg;
                    let catalogFlg = response.data.response.catalogFlg;
                    let orderStatusByHagaki = response.data.response.orderStatusByHagaki;
                    let zenkaiShouhinFlg = response.data.response.zenkaiShouhinFlg;
                    let entetsuHojinChangePsdFlg = response.data.response.entetsuHojinChangePsdFlg;

                    if (loginProblem == "ERROR_LAST_LOGIN_DATE") {
                        _this.listMessValid.push(loginMsg);
                        _this.$emit("event-loading", false);
                        return;
                    } else if (loginProblem == "WARN_EXPIRED_PASSWORD") {
                        _this.showConfirmChangePass(loginMsg);
                        _this.$emit("event-loading", false);
                        return;
                    } else if (loginProblem == "ERROR_EXPIRED_PASSWORD") {
                        _this.gotoChangePassScreen();
                        _this.$emit("event-loading", false);
                        return;
                    } else if (catalogFlg == "1" && orderStatusByHagaki == "1") {
                        location.href = response.data.response.moveUrl;
                        _this.$emit("event-loading", false);
                        return;
                    } else if (zenkaiShouhinFlg == 1) {
                        _this.showConfirmSaveShowhin();
                        _this.$emit("event-loading", false);
                        return;
                    }else if (entetsuHojinChangePsdFlg == 1){
                        _this.gotoChangePassScreen();
                        _this.$emit("event-loading", false);
                        return;
                    }

                    _this.$router.go(0);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt060');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            // common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /**
         * logout system
         */
        doLogout: function(){
            var _this = this;
            if(_this.pt060Init.cartItemSu == 0 || _this.pt060Init.optLogOutDelWKFlg == 1){
               _this._logout();
            } else{
                _this.isShowAlert = true;
            }
        },
        reload: function() {
            sessionStorage.currentURL = this.$route.fullPath;
            if (sessionStorage.currentURL == this.currentURL) {
                this.$router.go(0);
            }
        },
        /**
         * logout function
         */
        _logout: function(){
            var _this = this;
            _this.isShowAlert = false;
            //clear msg valid
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt060');
            _this.$emit("event-loading", true);
            // Call API login
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT060 + _this.$UrlConstants.LOGOUT).then(function(response) {
                if(response.data.status == 'OK'){
                    //reset page
                    var site = _this.$router.history.current.fullPath.split("/")[1];
                    common.removeLocalStorageEcSite(site);
                    
                    if (_this.pt060Init.entetsuFlg){
                        sessionStorage.setItem('entetsu_logout_flg', '1');
                    }
                    _this.reload();
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt060');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            // common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        /**
         * New member registration
         */
        doEntry: function(){
            var _this = this;
            const parameter = _this.generateLinkParams(8, _this.pt060Init.customerPage);
            _this.$router.push(parameter);
        },
        showConfirmChangePass: function(message) {
            var _this = this;

            _this.msgConfirm = message + "<br/>" + _this.$i18n.t('common.messages.confirmChangePass');
            _this.confirmActionFlg = 1;
            _this.isShowWarn = true;
        },
        showConfirmSaveShowhin: function() {
            var _this = this;

            _this.msgConfirm = _this.$i18n.t('common.messages.addedShouhinAdd');
            _this.confirmActionFlg = 2;
            _this.isShowWarn = true;
        },

        doAction: function(){
            var _this = this;

            switch (_this.confirmActionFlg) {
                case 1:
                    // Go to change password screen
                    _this.gotoChangePassScreen();
                    break;
                case 2:
                    _this.doInsertAddedProduct();
                    break;
                default:
                    null;
            }

            // Hide alert confirm 
            _this.isShowWarn = false;
            _this.confirmActionFlg = 0;
        },

        cancelAction: function() {
            var _this = this;

            switch (_this.confirmActionFlg) {
                case 1,2:
                    _this.$router.go(0);
                    break;
                default:
                    null;
            }
            _this.confirmActionFlg = 0;
        },
        /*
        * 前回すでに追加された商品の追加
        */
        doInsertAddedProduct: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            // Call API nologin
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH011 + _this.$UrlConstants.ADDED_SHOUHIN_INS).then(function(response) {
               //TODO: check status login
                if(response.data.status == "OK"){
                    // カートの確認画面へ遷移
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
            });
        },
        gotoChangePassScreen: function() {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: _this.SiteConstants.CHANGE_PASSWORD_PAGE }});
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        }
    }
}
</script>